export function generateSecurePassword(length = 12) {
	const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let password = ''
	const randomArray = new Uint8Array(length)
	crypto.getRandomValues(randomArray)
	for (let i = 0; i < length; i++) {
		const randomIndex = randomArray[i] % charset.length
		password += charset[randomIndex]
	}
	return password
}
